<ng-container>
  <form [formGroup]="form" class="group-filter-form">
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
        @for (type of getTypes(); track type) {
          <mat-option [value]="type.value">
            {{ type.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Condition</mat-label>
      <mat-select formControlName="condition">
        @for (condition of getConditions(); track condition) {
          <mat-option [value]="condition.value">
            {{ condition.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (filterType !== 'age') {
      <mat-form-field>
        <mat-label>Values</mat-label>
        <mat-select formControlName="values" multiple>
          @if (shouldShowValueSearch()) {
            <mat-option>
              <ngx-mat-select-search
                [formControl]="valueSearchControl"
                noEntriesFoundLabel="No matches"
                placeholderLabel="Search..."
              ></ngx-mat-select-search>
            </mat-option>
          }
          @for (value of getFilteredValues(); track trackByValue($index, value)) {
            <mat-option [value]="value.value">
              {{ value.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (filterType === 'age' && acceptsMultipleValues()) {
      <app-list-input
        formControlName="values"
        [label]="'Values'"
        />
    }
    @if (filterType === 'age' && !acceptsMultipleValues()) {
      <mat-form-field>
        <mat-label>Value</mat-label>
        <input matInput formControlName="values" />
      </mat-form-field>
    }
  </form>
</ng-container>
